module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentProgress !== 'action') ? _c('CurrentLocationPanel') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-panel-wrapper"
  }, [(_vm.currentProgress === 'setMaxStock') ? _c('confirmMaxStock', {
    on: {
      "setMaxAmountData": _vm.getMaxAmountData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setExpiredDate') ? _c('confirmExpirationDate', {
    on: {
      "setExpirationDate": _vm.getExpirationDate
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.maxAmount,
      "deviceId": _vm.$store.state.device.currentDevice.id,
      "autoCaculateAmount": true,
      "checkNum": _vm.maxAmount,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h6', [_vm._v("此藥盒新增數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e840632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateDrugFlow/ConfirmFlow.vue
// module id = 1470
// module chunks = 1